import { ReactElement } from 'react';

import MedicareTool from '~components/MedicareTools/MedicareToolsButton';

type SimpleChildElementModel = {
    type: string;
    props: {
        children: string | Array<string | SimpleChildElementModel>;
        className: string;
        id: string;
    };
};

interface IAccordionMarketingProps {
    backgroundsurface: SupportedBackgroundColor;
    textcolor: SupportedTextColor;
    children: ReactElement<SimpleChildElementModel>[];
}

const DoctorTool = ({
    backgroundsurface,
    textcolor,
    children,
}: React.PropsWithChildren<IAccordionMarketingProps>) => {
    return (
        <MedicareTool
            buttontype="secondary"
            btnWidth="w-full"
            trackingName=""
            toolname="doctor"
            label="Add doctors"
            fontSize="text-xl"
        />
    );
};

export default DoctorTool;
